import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.oms')
  .factory('OmsOrderAPI', OmsOrderAPI);

function OmsOrderAPI(): BringozApi {
  return {
    base: `/oms/orders-v2`,
    infiniteScroll: {
      address: `/oms/orders-v2`,
      cmd: 'GET'
    },
    actions: {
      totals: {
        address: 'query/totals',
        cmd: 'POST',
        updateable: false
      },
      quantities: {
        address: 'query/quantities',
        cmd: 'POST',
        updateable: false
      },
      export: {
        address: 'bulk/export',
        cmd: 'POST',
        updateable: false
      },
      getPricingOffer: {
        address: 'pricing/offer',
        cmd: 'POST',
        updateable: false
      },
      create: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      createMultiple: {
        address: 'createMultiple',
        cmd: 'PUT',
        updateable: true
      },
      createMultipleWithSettings: {
        address: 'createMultipleWithSettings',
        cmd: 'PUT',
        updateable: true
      },
      update: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      updateOperationalContacts: {
        address: '{id}/operationalContacts',
        cmd: 'POST',
        updateable: true
      },
      cancel: {
        address: 'cancel/{id}',
        cmd: 'POST',
        updateable: true
      },
      cancelBulk: {
        address: 'bulk/cancel',
        cmd: 'POST',
        updateable: true
      },
      updateProjectSettings: {
        address: '{id}/settings',
        cmd: 'POST',
        updateable: false
      },
      scheduleSelfPickup: {
        address: '{id}/selfPickups',
        cmd: 'PUT',
        updateable: false
      },
      scheduleDeliveries: {
        address: 'dispatch',
        cmd: 'PUT',
        updateable: false
      },
      get3plsAssignOptions: {
        address: '{orderId}/3pl/quote',
        cmd: 'GET',
        updateable: false
      },
      assignToSupplier: {
        address: '{orderId}/3pl/quote',
        cmd: 'POST',
        updateable: false
      },
      addNote: {
        address: '{orderId}/note',
        cmd: 'POST',
        updateable: true
      },
      validateServiceAreas: {
        address: 'valid/area',
        cmd: 'POST',
        updateable: false
      },
      bulkDispatch: {
        address: 'bulk/dispatch',
        cmd: 'POST',
        updateable: true
      },
      getOrderInfo: {
        address: '{orderId}/info',
        cmd: 'GET',
        updateable: false
      },
      getOrderTaskTimeSlots: {
        address: 'timeSlot/options',
        cmd: 'GET',
        updateable: false
      },
      autoDispatch: {
        address: '{orderId}/autoDispatch',
        cmd: 'PUT',
        updateable: false
      },
      updateCompletedOrder: {
        address: '{orderId}/finished',
        cmd: 'POST',
        updateable: false
      },
      getLogsTimeline: {
        address: '{orderId}/timeline',
        cmd: 'GET',
        updateable: true
      },
      recoverOrder: {
        address: '{orderId}/recover',
        cmd: 'POST',
        updateable: true
      },
      sendSchedulingLink: {
        address: '{orderId}/trigger-delivery-scheduling',
        cmd: 'POST',
        updateable: true
      },
      sendSchedulingLinkWhatsapp: {
        address: '{orderId}/trigger-delivery-scheduling-whatsapp',
        cmd: 'POST',
        updateable: true
      },
      getSchedulingForm: {
        address: '{orderId}/get-delivery-scheduling-form',
        cmd: 'GET',
        updateable: true
      },
      onHold: {
        address: '{id}/onHold',
        cmd: 'POST',
        updateable: true
      },
      resume: {
        address: '{id}/resume',
        cmd: 'POST',
        updateable: true
      },
      manuallyComplete: {
        address: '{id}/manuallyComplete',
        cmd: 'POST',
        updateable: true
      },
      globalSearch: {
        address: 'super/search',
        cmd: 'GET',
        updateable: true
      },
      emailBOL: {
        address: '{id}/billoflading/send',
        cmd: 'POST',
        updateable: true
      },
      cancelFulfillmentLines: {
        address: '{id}/fulfillmentLine',
        cmd: 'DELETE',
        updateable: true
      },
      createReturnDeliveryOrder: {
        address: '{orderId}/return/{fulfillmentLineId}',
        cmd: 'PUT',
        updateable: true
      },
      bulkUpdate: {
        address: 'bulk/update',
        cmd: 'POST',
        updateable: true
      },
      deleteNote: {
        address: '{orderId}/note',
        cmd: 'DELETE',
        updateable: true
      },
      bulkSendSchedulingLink: {
        address: 'bulk/triggerDeliveryScheduling',
        cmd: 'POST',
        updateable: true
      },
      bulkSendSchedulingLinkWhatsapp: {
        address: 'bulk/triggerDeliverySchedulingWhatsapp',
        cmd: 'POST',
        updateable: true
      },
      updateOrderMetaData: {
        address: '{orderId}/metadata',
        cmd: 'PUT',
        updateable: true
      },
      updateOrdersMetaData: {
        address: 'bulk/metadata',
        cmd: 'POST',
        updateable: true
      }
    }
  }
}
